import styled from 'styled-components';

import { Flex } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
  /* min-width of constellation PropertyCard */
  min-width: 286px;
`;
